import { Endpoint } from '@/types/api.type.ts';

export const documentEndpoints: Endpoint[] = [
    {
        name: 'GetDocuments',
        method: 'get',
        path: '/documents',
    },
    {
        name: 'CreateDocument',
        method: 'post',
        path: '/documents',
    },
    {
        name: 'GetDocumentData',
        method: 'get',
        path: '/documents/:id',
    },
    {
        name: 'DeleteDocument',
        method: 'delete',
        path: '/documents/:id',
    },
];
